import moment from 'moment';
import 'moment/locale/ko';
import React, { useCallback, useMemo, useState } from 'react';
import DatePicker from 'react-datepicker';
import { getMAJAD030 } from '../../../services/Api';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_STATISTICAL } from '../../../shared/constants/app';
const MAJAD030 = () => {
    const today = moment().toDate();
    const [date, setDate] = useState(moment().subtract(1, 'day').toDate());
    const [currentMonth, setCurrentMonth] = useState(moment(date).month());
    const [currentYear, setCurrentYear] = useState(moment(date).year());
    const [currentDaySummary, setCurrentDaySummary] = useState([]);
    const [dailySummary, setDailySummary] = useState([]);
    const [yearlySummary, setYearlySummary] = useState([]);

    const handleDateChange = (date) => {
        const dateFormat = date ? moment(date).format('YYYY/MM/DD') : moment().subtract(1, 'day').format('YYYY/MM/DD');
        setDate(dateFormat);
    };

    const handleSearch = () => {
        const dateFormat = date ? moment(date).format('YYYY-MM-DD') : null;
        const newMonth = moment(date).month();
        const newYear = moment(date).year();
        getMAJAD030(dateFormat)
            .then((res) => {
                setCurrentDaySummary(res.data.currentDaySummary);
                setDailySummary(res.data.dailySummary);
                setYearlySummary(res.data.yearlySummary);
                setCurrentMonth(newMonth);
                setCurrentYear(newYear);
            })
            .catch((error) => console.log(error));
    };

    const handleReset = () => {
        setDate(today);
    };

    const totalsYearlySummary = useMemo(() => {
        return yearlySummary.reduce(
            (acc, item) => {
                acc.cproposeSendCntTot += item.cproposeSendCntTot || 0;
                acc.cproposeSendMemberCntTot += item.cproposeSendMemberCntTot || 0;
                acc.pproposeSendCntTot += item.pproposeSendCntTot || 0;
                acc.pproposeSendMemberCntTot += item.pproposeSendMemberCntTot || 0;
                acc.presumeYtoDayCntTot += item.presumeYtoDayCntTot || 0;
                acc.presumeNtoDayCntTot += item.presumeNtoDayCntTot || 0;
                acc.presumeNMemberCntTot += item.presumeNMemberCntTot || 0;
                acc.presumeNSystemCntTot += item.presumeNSystemCntTot || 0;
                acc.presumeUpdateCntTot += item.presumeUpdateCntTot || 0;
                acc.presumeYDateCntAvg += item.presumeYDateCntAvg || 0;
                acc.ponlineCntTot += item.ponlineCntTot || 0;
                acc.ponlineMemberCntTot += item.ponlineMemberCntTot || 0;
                return acc;
            },
            {
                cproposeSendCntTot: 0,
                cproposeSendMemberCntTot: 0,
                pproposeSendCntTot: 0,
                pproposeSendMemberCntTot: 0,
                presumeYtoDayCntTot: 0,
                presumeNtoDayCntTot: 0,
                presumeNMemberCntTot: 0,
                presumeNSystemCntTot: 0,
                presumeUpdateCntTot: 0,
                presumeYDateCntAvg: 0,
                ponlineCntTot: 0,
                ponlineMemberCntTot: 0,
            },
        );
    }, [yearlySummary]);
    function makeEventList(item) {
        return [
            `(C)쪽지발송 : ${item.cproposeSendCnt || 0}`,
            `(C)쪽지발송회원 : ${item.cproposeSendMemberCnt || 0}`,
            `(P)쪽지발송 : ${item.pproposeSendCnt || 0}`,
            `(P)쪽지발송회원 : ${item.pproposeSendMemberCnt || 0}`,
            `(P)이력전체 : ${item.presumeYDateCnt || 0}`,
            `(P)이력게재(new) : ${item.presumeYtoDayCnt || 0}`,
            `(P)이력보관(new) : ${item.presumeNtoDayCnt || 0}`,
            `(P)이력보관(변경) : ${item.presumeUpdateCnt || 0}`,
            `(P)이력보관(시스템) : ${item.presumeNSystemCnt || 0}`,
            `(P)이력업데이트 : ${item.presumeYDateCnt || 0}`,
            `(P)온라인지원 : ${item.ponlineCnt || 0}`,
            `(P)온라인지원회원 : ${item.ponlineMemberCnt || 0}`,
            `(P)안심번호전체 : ${item.psafeNumberCnt || 0}`,
            `(P)안심번호(new) : ${item.psafeNumberDateCnt || 0}`,
        ];
    }

    // Sử dụng useMemo để chỉ tính lại dữ liệu lịch khi currentMonth hoặc currentYear thay đổi
    const calendarData = useMemo(() => {
        const eventData = {};
        dailySummary?.forEach((item) => {
            const dateKey = item.sdate;
            // Tạo mảng chuỗi sự kiện
            const eventList = makeEventList(item);
            // Gán vào eventData
            eventData[dateKey] = eventList;
        });
        const rawFirstDay = new Date(currentYear, currentMonth, 1).getDay();
        const firstDay = rawFirstDay === 0 ? 6 : rawFirstDay - 1;
        const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
        const prevMonthDays = new Date(currentYear, currentMonth, 0).getDate();
        let date = 1;
        let prevDate = prevMonthDays - firstDay + 1;
        const grid = [];

        for (let i = 0; i < 6; i++) {
            const week = [];
            for (let j = 0; j < 7; j++) {
                // Trường hợp hiển thị ngày của tháng trước
                if (i === 0 && j < firstDay) {
                    week.push({ day: prevDate, isCurrentMonth: false });
                    prevDate++;
                } else if (date > daysInMonth) {
                    // Ngày của tháng sau
                    week.push({ day: date - daysInMonth, isCurrentMonth: false });
                    date++;
                } else {
                    // Ngày của tháng hiện tại
                    const fullDate = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${String(
                        date,
                    ).padStart(2, '0')}`;
                    week.push({
                        day: date,
                        isCurrentMonth: true,
                        fullDate,
                        events: eventData[fullDate] || [],
                        // Đánh dấu chủ nhật
                        isSunday: j === 6,
                    });
                    date++;
                }
            }
            grid.push(week);
            // Nếu đã vượt qua số ngày của tháng hiện tại, có thể break sớm
            if (date > daysInMonth) break;
        }
        return grid;
    }, [currentMonth, currentYear, dailySummary]);

    // Sử dụng useCallback để không tái tạo lại các hàm khi component re-render
    const handlePrevMonth = useCallback(() => {
        let newMonth = currentMonth - 1;
        let newYear = currentYear;
        if (newMonth < 0) {
            newMonth = 11;
            newYear--;
        }
        setCurrentMonth(newMonth);
        setCurrentYear(newYear);
    }, [currentMonth, currentYear]);

    const handleNextMonth = useCallback(() => {
        let newMonth = currentMonth + 1;
        let newYear = currentYear;
        if (newMonth > 11) {
            newMonth = 0;
            newYear++;
        }
        setCurrentMonth(newMonth);
        setCurrentYear(newYear);
    }, [currentMonth, currentYear]);

    return (
        <div>
            <div className="container-fluid container statis-page">
                <div className="content wrap">
                    <SideMenu menu={MENU_STATISTICAL} />
                    <div className=" content-right">
                        <div className="title">기타집계현황</div>
                        <div>
                            <table className="table-gray">
                                <tbody>
                                    <tr>
                                        <th style={{ width: 150 }}>일자</th>
                                        <td colSpan={3}>
                                            <div className="flex group-item">
                                                <div className="group-date">
                                                    <DatePicker
                                                        style={{ width: 200 }}
                                                        onChange={(date) => handleDateChange(date, 'date')}
                                                        locale="ko"
                                                        placeholderText="YYYY/MM/DD"
                                                        dateFormat="yyyy/MM/dd"
                                                        selected={date}
                                                        maxDate={today}
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        scrollableYearDropdown
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="group-button center">
                                <button
                                    className="btn btn-gray-bold"
                                    onClick={() => {
                                        handleSearch();
                                    }}
                                >
                                    검색
                                </button>
                                <button
                                    className="btn btn-gray-thin"
                                    onClick={() => {
                                        handleReset();
                                    }}
                                >
                                    초기화
                                </button>
                            </div>
                        </div>
                        <div className="table-padding-5">
                            <div className="count-item">

                            </div>
                            <table className="table-gray custom-table-other-job">
                                <thead>
                                    <tr>
                                        <th rowSpan={4}>구분</th>
                                        <th colSpan={2} rowSpan={1}>
                                            치과회원
                                        </th>
                                        <th colSpan={10} rowSpan={1}>
                                            개인회원
                                        </th>
                                    </tr>
                                    <tr>
                                        <th colSpan={2}>{currentYear}년</th>
                                        <th colSpan={10}>{currentYear}년</th>
                                    </tr>
                                    <tr>
                                        <th colSpan={2}>쪽지</th>
                                        <th colSpan={2}>쪽지</th>
                                        <th colSpan={6}>이력서</th>
                                        <th colSpan={2}>온라인지원</th>
                                    </tr>
                                    <tr>
                                        <th colSpan={1}>발송건</th>
                                        <th colSpan={1}>발송회원</th>
                                        <th colSpan={1}>발송건</th>
                                        <th colSpan={1}>발송회원</th>
                                        <th colSpan={1}>
                                            게재
                                            <br />
                                            (New)
                                        </th>
                                        <th colSpan={1}>
                                            보관
                                            <br />
                                            (New)
                                        </th>
                                        <th colSpan={1}>
                                            보관
                                            <br />
                                            (변경)
                                        </th>
                                        <th colSpan={1}>
                                            보관
                                            <br />
                                            (시스템)
                                        </th>
                                        <th colSpan={1}>업데이트</th>
                                        <th colSpan={1}>
                                            게재전체
                                            <br />
                                            (평균)
                                        </th>
                                        <th colSpan={1}>지원건</th>
                                        <th colSpan={1}>지원회원</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {yearlySummary &&
                                        yearlySummary.length > 0 &&
                                        yearlySummary.map((item) => (
                                            <tr key={item.mon}>
                                                <td>{item.mon}월</td>
                                                <td>{item.cproposeSendCntTot?.toLocaleString()}</td>
                                                <td>{item.cproposeSendMemberCntTot?.toLocaleString()}</td>
                                                <td>{item.pproposeSendCntTot?.toLocaleString()}</td>
                                                <td>{item.pproposeSendMemberCntTot?.toLocaleString()}</td>
                                                <td>{item.presumeYtoDayCntTot?.toLocaleString()}</td>
                                                <td>{item.presumeNtoDayCntTot?.toLocaleString()}</td>
                                                <td>{item.presumeNMemberCntTot?.toLocaleString()}</td>
                                                <td>{item.presumeNSystemCntTot?.toLocaleString()}</td>
                                                <td>{item.presumeUpdateCntTot?.toLocaleString()}</td>
                                                <td>{item.presumeYDateCntAvg?.toLocaleString()}</td>
                                                <td>{item.ponlineCntTot?.toLocaleString()}</td>
                                                <td>{item.ponlineMemberCntTot?.toLocaleString()}</td>
                                            </tr>
                                        ))}
                                    <tr>
                                        <td>Total</td>
                                        <td>{totalsYearlySummary.cproposeSendCntTot.toLocaleString()}</td>
                                        <td>{totalsYearlySummary.cproposeSendMemberCntTot.toLocaleString()}</td>
                                        <td>{totalsYearlySummary.pproposeSendCntTot.toLocaleString()}</td>
                                        <td>{totalsYearlySummary.pproposeSendMemberCntTot.toLocaleString()}</td>
                                        <td>{totalsYearlySummary.presumeYtoDayCntTot.toLocaleString()}</td>
                                        <td>{totalsYearlySummary.presumeNtoDayCntTot.toLocaleString()}</td>
                                        <td>{totalsYearlySummary.presumeNMemberCntTot.toLocaleString()}</td>
                                        <td>{totalsYearlySummary.presumeNSystemCntTot.toLocaleString()}</td>
                                        <td>{totalsYearlySummary.presumeUpdateCntTot.toLocaleString()}</td>
                                        <td>{totalsYearlySummary.presumeYDateCntAvg.toLocaleString()}</td>
                                        <td>{totalsYearlySummary.ponlineCntTot.toLocaleString()}</td>
                                        <td>{totalsYearlySummary.ponlineMemberCntTot.toLocaleString()}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="table table-gray custom-th" style={{ marginTop: 60 }}>
                                <thead>
                                    <tr>
                                        <th>마감일</th>
                                        <th>이력서 게재 전체</th>
                                        <th>이력서 보관 전체</th>
                                        <th>안심번호 사용건 전체(게재중)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        {currentDaySummary &&
                                            currentDaySummary?.length > 0 &&
                                            currentDaySummary?.map((item) => (
                                                <>
                                                    <td>{item.sdate}</td>
                                                    <td>{item?.presumeYDateCnt > 0 ? item?.presumeYDateCnt.toLocaleString() : '0'}</td>
                                                    <td>{item?.presumeNDateCnt > 0 ? item?.presumeNDateCnt.toLocaleString() : '0'}</td>
                                                    <td>{item?.psafeNumberDateCnt > 0 ? item?.psafeNumberDateCnt.toLocaleString() : '0'}</td>
                                                </>
                                            ))}
                                    </tr>
                                </tbody>
                            </table>
                            <table className="calendar-table w-full p-no-absolute">
                                <thead>
                                    <tr>
                                        <th onClick={handlePrevMonth}>
                                            <i className="icon icon-prev" />
                                        </th>
                                        <th colSpan={5} id="monthYear">
                                            {`${currentYear}년 ${currentMonth + 1}월`}
                                        </th>
                                        <th onClick={handleNextMonth}>
                                            <i className="icon icon-next" />
                                        </th>
                                    </tr>
                                    <tr>
                                        <td>월</td>
                                        <td>화</td>
                                        <td>수</td>
                                        <td>목</td>
                                        <td>금</td>
                                        <td>토</td>
                                        <td>일</td>
                                    </tr>
                                </thead>
                                <tbody id="calendar-body">
                                    {calendarData?.map((week, weekIndex) => (
                                        <tr key={weekIndex}>
                                            {week?.map((cell, cellIndex) => (
                                                <td
                                                    key={cellIndex}
                                                    className={
                                                        cell.isCurrentMonth
                                                            ? cell.isSunday
                                                                ? 'red-data'
                                                                : ''
                                                            : 'other-month'
                                                    }
                                                >
                                                    <span>{cell.day}</span>
                                                    {cell.isCurrentMonth &&
                                                        cell?.events?.map((event, idx) => <p key={idx}>{event}</p>)}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MAJAD030;
